export default __webpack_public_path__ + "static/media/city_demo_hidef.af52d296.PNG";